module.exports = {
	"pathContext": {
		"path": "/shop/merino-round-cushion/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop-merino-round-cushion.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop-merino-round-cushion.json
// module chunks = 218581296251300